// @flow

import { apiClients } from '@app/services/api/clients'
import { getApiClient } from '@app/utils/apiUtils'

/**
 * API to reveal the full contact number for a given order
 */
export const revealContactApi = (country: string, orderId: string): Promise<any> => {
  const client = getApiClient(apiClients, country)
  const url = `2.0/orders/${orderId}`
  return client.get(url)
}
